import { IProductsList } from "../dto/IProducts";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  formatDate,
  getCorrectLanguage,
} from "../../../shared/functions/Functions";
import { CustomImageHandler } from "../../../shared/components/CustomImageHandler";
import { useTranslation } from "react-i18next";
import { ConfirmDelete } from "../../../shared/components/ConfirmDelete";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { PreviewProductModal } from "./PreviewProductModal";
import { ProductsService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { Offcanvas } from "react-bootstrap";
import { ChatGptContent } from "../content/components/ChatGptContent";

interface IProductsListViewProps {
  workflow?: boolean;
  toForLink?: string;
  variationsTable?: boolean;
  firstView?: boolean;
  headerName?: string;
  attOrExp?: string;
  nameOfTable?: string;
  checkedValues?: number[];
  infoButton?: boolean;
  product: IProductsList | any;
  deleteHandler: (
    product: IProductsList,
    selectedProduct: IProductsList
  ) => void;
  onEdit: (e: any, id: number) => any;
  toForLinkFunc?: (idProduct: number) => string;
  onView?: (id: number) => void;
  handleCheck?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  mainTable?: boolean;
  showActionButtons?: boolean;
  showAssignColumn?: boolean;
  status?: boolean;
  showDeleteButton?: boolean;
  showViewButton?: boolean;
  staticsView2?: any;
  listWithoutLinks?: boolean;
  usedLanguagesArray?: any;
  setTriggerUpdate?: any;
}
interface IMessage {
  content: string;
  role: "assistant" | "user";
  sent?: Date;
}
export const ProductsListView = ({
  listWithoutLinks = false,
  toForLinkFunc,
  workflow = false,
  toForLink,
  firstView = false,
  variationsTable = false,
  headerName,
  staticsView2,
  infoButton,
  product,
  deleteHandler,
  onEdit,
  onView,
  mainTable,
  handleCheck,
  status,
  showDeleteButton = true,
  showActionButtons = true,
  showAssignColumn = false,
  showViewButton = true,
  nameOfTable,
  checkedValues,
  attOrExp,
  usedLanguagesArray,
  setTriggerUpdate,
}: IProductsListViewProps) => {
  const { t } = useTranslation();
  const { accessRights, roles } = useSelector(
    (state: IAllStates) => state.auth
  );
  const [messages, setMessages] = useState<IMessage[]>([]);
  const viewBtnVisible = accessRights?.includes("product_can_preview");
  const userClientDashboard = accessRights?.includes(
    "client_dashboard_can_view"
  );
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showChatGpt, setShowChatGpt] = useState(false);
  const [productBaseData, setProductBaseData] = useState();
  const isManager = roles?.includes("ROLE_MANAGER");
  const isAdmin = roles?.includes("ROLE_ADMIN");
  const isCompanyAdmin = roles?.includes("ROLE_COMPANY_ADMIN");
  const [selectedProduct, setSelectedProduct] = useState<IProductsList>();
  const [selectedVariation, setSelectedVariation] = useState<any>();
  const [show, setShow] = useState(false);
  const { id } = useParams();
  const idExport = id;
  const [previewId, setPreviewId] = useState(0);
  const navigate = useNavigate();
  const isExportList = window.location.pathname?.includes("app/export/list/");
  const isManage = window.location.pathname?.includes("app/products/manage");
  const handleShow = () => setShow(true);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [disabledDeleteBtn, setDisabledDeleteBtn] = useState(false);

  const editDisabledBtn = () => {
    if (
      nameOfTable === "baseData" &&
      accessRights?.includes("product_base_data_can_edit")
    ) {
      return false;
    } else if (
      nameOfTable === "attributes" &&
      accessRights?.includes("product_attributes_can_edit")
    ) {
      return false;
    } else if (
      nameOfTable === "media" &&
      accessRights?.includes("product_media_module_can_edit")
    ) {
      return false;
    } else if (
      nameOfTable === "content" &&
      accessRights?.includes("product_content_can_edit")
    ) {
    } else if (accessRights?.includes("workflow_can_update")) {
      return false;
    } else if (nameOfTable === "pending") {
      return false;
    } else if (nameOfTable === "contentWorkflow") {
      return false;
    } else if (nameOfTable === "translator") {
      return false;
    } else if (nameOfTable === "crawled") {
      return false;
    } else if (nameOfTable === "productByAttribute") {
      return false;
    } else {
      return true;
    }
  };
  const checkForCheckbox = () => {
    if (
      nameOfTable === "baseMainWorkflow" &&
      (isAdmin || isCompanyAdmin || isManager)
    ) {
      return true;
    } else {
      switch (nameOfTable) {
        case "baseData":
          return true;
        case "attributes":
          return true;
        case "content":
          return true;
        case "media":
          return true;
        case "pending":
          return true;
        default:
          return false;
      }
    }
  };
  const accessUserClientDashboard = () => {
    if (userClientDashboard && !isAdmin && !isCompanyAdmin && !isManager) {
      return false;
    } else {
      return true;
    }
  };
  const handleShowAssignColumn = () => {
    if (product?.additionalInformation?.copyWriter) {
      return `${product?.additionalInformation?.copyWriter?.firstName} ${
        product?.additionalInformation?.copyWriter?.lastName ?? ""
      }`;
    } else if ((product as any)?.workflowProduct?.translator) {
      return `${(product as any)?.workflowProduct?.translator?.firstName} ${
        (product as any)?.workflowProduct?.translator?.lastName ?? ""
      }`;
    } else if ((product as any)?.worker) {
      return `${(product as any)?.worker?.firstName} ${
        (product as any)?.worker?.lastName ?? ""
      }`;
    } else {
      return "-";
    }
  };
  const checkForFinished = () => {
    if (product?.additionalInformation || (product as any)?.workflowProduct) {
      return true;
    } else {
      return false;
    }
  };
  const customFuncForTo = (productId: number) => {
    return (
      workflow
        ? toForLinkFunc && toForLinkFunc(product?.id as number)
        : !editDisabledBtn()
        ? `${toForLink}${product.id}`
        : "#"
    ) as string;
  };
  useEffect(() => {
    if (product?.lockedProduct) {
      setDisabledBtn(product?.lockedProduct);
    }
  }, [product, accessRights]);
  useEffect(() => {
    if (
      ![
        "product_attributes_can_edit",
        "product_can_delete",
        "workflow_can_delete",
      ].some((right) => accessRights?.includes(right))
    ) {
      setDisabledDeleteBtn(true);
    }
  }, [accessRights]);

  const onEditAtt = (id: number, status: string, isImported: boolean) => {
    if (status === "APPROVED") {
      navigate(`/app/products/base-data/${id}`, {
        state: { close: attOrExp, idExport: idExport, headerName: headerName },
      });
    } else if (isImported === true) {
      navigate(`/app/pending-products/imported/base-data/${id}`, {
        state: { close: attOrExp, idExport: idExport, headerName: headerName },
      });
    } else {
      navigate(`/app/pending-products/crawled/base-data/${id}`, {
        state: { close: attOrExp, idExport: idExport, headerName: headerName },
      });
    }
  };

  const isFinishedStep = () => {
    return (
      product?.additionalInformation?.isBaseDataDone ||
      product?.additionalInformation?.isAttributesDone ||
      product?.additionalInformation?.isCopyWritingDone
    );
  };

  const handleProductClick = (productId: number) => {
    ProductsService.getProductById(+productId, "BASE_DATA")
      .then((response) => {
        setProductBaseData(response);
        setShowOffcanvas(true);
      })
      .catch((error) => ErrorToast(error));
  };
  const handleCloseOffcanvas = () => setShowOffcanvas(false);
  const handleSave = (e: any) => {
    e.preventDefault();
    ProductsService.updateProductPreview(
      productBaseData,
      Number((productBaseData as any)?.id)
    )
      .then((response) => {
        console.log((productBaseData as any)?.translation?.en?.description);
        SuccessToast(`${t("toasts.successfully_updated")}`);
        setTriggerUpdate((prev: boolean) => !prev);
      })
      .catch((error) => ErrorToast(error));
  };
  const handleChangeCheck = (e: any) => {
    e.preventDefault();
    ProductsService.updateProductCheckPreview(
      Number((productBaseData as any)?.id)
    )
      .then((response) => {
        const status = response?.status;
        SuccessToast(`${t("toasts.successfully_updated")}`);
        setTriggerUpdate((prev: boolean) => !prev);
      })
      .catch((error) => ErrorToast(error));
  };

  return (
    <>
      <>
        <Offcanvas
          show={showOffcanvas}
          onHide={handleCloseOffcanvas}
          placement="end"
          style={{
            width: "70%",
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {t("preview_product.preview_product")}
            </Offcanvas.Title>
            <div className="d-flex justify-content-end">
              {window.location.pathname?.includes("workflow/step9/") && (
                <button
                  className="btn btn-secondary me-2"
                  onClick={(e: any) => handleChangeCheck(e)}
                >
                  {t("preview_product.check")}
                </button>
              )}

              <button
                className="btn btn-secondary me-2"
                onClick={(e) => handleSave(e)}
              >
                {t("global.save")}
              </button>

              <button
                className="btn btn-primary d-flex align-items-center me-2"
                onClick={() => setShowChatGpt(true)}
              >
                <i className="ri-message-3-line me-1" />
                {t("products.chatGpt")}
              </button>
            </div>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <PreviewProductModal
              productBaseData={productBaseData}
              setProductBaseData={setProductBaseData}
              usedLanguagesArray={usedLanguagesArray}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </>
      <>
        <Offcanvas
          show={showChatGpt}
          onHide={() => setShowChatGpt(false)}
          placement="end"
          className="main-height w-50"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>{t("products.chatGpt")}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ChatGptContent messages={messages} setMessages={setMessages} />
          </Offcanvas.Body>
        </Offcanvas>
      </>
      <tr key={product?.id}>
        {
          /* {nameOfTable === "baseData" ||
        nameOfTable === "attributes" ||
        nameOfTable === "content" ||
        nameOfTable === "pending" ||
        (nameOfTable === "baseMainWorkflow" && ( */
          checkForCheckbox() && accessUserClientDashboard() && (
            <td>
              <input
                type="checkbox"
                className="form-check-input m-0 cursor-pointer"
                onChange={(e) => handleCheck && handleCheck(e)}
                value={product?.id}
                checked={checkedValues?.includes(Number(product?.id))}
              />
            </td>
          )
        }

        {/* // test))} */}
        <td>
          {listWithoutLinks ? (
            <>
              <span>#{product?.id}</span>
            </>
          ) : (
            <Link
              // to={
              //   workflow ? ( toForLinkFunc && toForLinkFunc(product?.id as number)): !editDisabledBtn()
              //     ? `${toForLink}${product.id}`
              //     : "#"
              // }
              to={customFuncForTo(product.id as number)}
              onClick={(e) => {
                if (!editDisabledBtn()) {
                  onEdit(e, product?.id as number);
                } else {
                  e.preventDefault();
                }
              }}
              onContextMenu={(e) => {
                if (!editDisabledBtn()) {
                  onEdit(e, product?.id as number);
                } else {
                  e.preventDefault();
                }
              }}
              className={`text-dark ${!editDisabledBtn() && "cursor-pointer"}`}
            >
              #{product?.id}
            </Link>
          )}
        </td>
        <td>
          {!editDisabledBtn() && !listWithoutLinks ? (
            <Link
              to={customFuncForTo(product.id as number)}
              onClick={(e) => {
                if (!editDisabledBtn()) {
                  onEdit(e, product?.id as number);
                } else {
                  e.preventDefault();
                }
              }}
              onContextMenu={(e) => {
                if (!editDisabledBtn()) {
                  onEdit(e, product?.id as number);
                } else {
                  e.preventDefault();
                }
              }}
              className={`text-dark ${!editDisabledBtn() && "cursor-pointer"}`}
            >
              {product?.eanCode ?? "-"}
            </Link>
          ) : (
            <span className="text-dark">{product?.eanCode ?? "-"}</span>
          )}
        </td>
        {nameOfTable === "translator" && (
          <td>
            {!!(product as any)?.workflowProduct?.assignedTo
              ? (product as any)?.workflowProduct?.assignedTo
                  ?.map(
                    (language: any) =>
                      `${getCorrectLanguage(language as any, t)}`
                  )
                  .join(", ")
              : "-"}
          </td>
        )}
        {firstView ? (
          <>
            {!isManage && (
              <td>
                <span
                  className={`badge badge-outline-${
                    (product as any)?.workflowProduct?.isTranslationDone
                      ? "success"
                      : "danger"
                  } badge-soft-${
                    (product as any)?.workflowProduct?.isTranslationDone
                      ? "success"
                      : "danger"
                  }`}
                >
                  {(product as any)?.workflowProduct?.isTranslationDone
                    ? "Yes"
                    : "No"}
                </span>
              </td>
            )}
          </>
        ) : (
          <>
            {checkForFinished() &&
              nameOfTable !== "translator" &&
              !isManage && (
                <td>
                  <span
                    className={`badge badge-outline-${
                      isFinishedStep() ? "success" : "danger"
                    } badge-soft-${isFinishedStep() ? "success" : "danger"}`}
                  >
                    {isFinishedStep() ? "Yes" : "No"}
                  </span>
                </td>
              )}
          </>
        )}
        {product?.workflowProduct && (
          <td>
            <span
              className={`badge badge-outline-${
                product?.workflowProduct.similar ? "success" : "danger"
              } badge-soft-${
                product?.workflowProduct.similar ? "success" : "danger"
              }`}
            >
              {product?.workflowProduct.similar ? "Yes" : "No"}
            </span>
          </td>
        )}
        {staticsView2?.length &&
          staticsView2?.map((item: any) => {
            return (
              <td key={item?.lang}>
                {(product as any)?.workflowProduct?.finished?.[
                  item?.lang as string
                ]?.isDone !== undefined ? (
                  (product as any)?.workflowProduct?.finished?.[
                    item?.lang as string
                  ]?.isDone ? (
                    <span className="badge badge-outline-success badge-soft-success">
                      {t("global.yes")}
                    </span>
                  ) : (
                    <span className="badge badge-outline-danger badge-soft-danger">
                      {t("global.no")}
                    </span>
                  )
                ) : (
                  ""
                )}
              </td>
            );
          })}
        {showAssignColumn && <td>{handleShowAssignColumn()}</td>}
        <td>
          <span className="d-flex justify-content-start">
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-sm bg-light rounded p-1">
                  <CustomImageHandler
                    path={product?.productPictures?.[0]?.path}
                    alt="Product"
                    classes="avatar-xs h-100 w-100"
                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {listWithoutLinks ? (
                    <>{product?.title ?? "-"}</>
                  ) : (
                    <Link
                      to={customFuncForTo(product.id as number)}
                      onClick={(e) => {
                        if (!editDisabledBtn()) {
                          onEdit(e, product?.id as number);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      onContextMenu={(e) => {
                        if (!editDisabledBtn()) {
                          onEdit(e, product?.id as number);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      className={`text-dark ${
                        !editDisabledBtn() && "cursor-pointer"
                      }`}
                    >
                      {product?.title ?? "-"}
                    </Link>
                  )}
                </h5>
              </div>
            </div>
          </span>
        </td>
        {window.location.pathname?.includes("/workflow/") && (
          <td>{product?.brand?.name ?? "-"}</td>
        )}

        {isExportList && <td>{(product?.variation as any)?.title ?? "-"}</td>}
        {status && <td>{(product?.status as string) ?? "-"}</td>}

        {nameOfTable === "pending" && (
          <td>{product.sapId ? product.sapId : "-"}</td>
        )}
        <td>{(product?.category as any)?.title ?? "Without category"}</td>
        <td>{formatDate(product?.createdAt)}</td>
        {nameOfTable === "preview" && (
          <td>
            <span
              className={`badge badge-outline-${
                product?.isChecked ? "success" : "danger"
              } badge-soft-${product?.isChecked ? "success" : "danger"}`}
            >
              {product?.isChecked ? "Yes" : "No"}
            </span>
          </td>
        )}
        {!isManage && (
          <td>
            {accessUserClientDashboard() ? (
              <>
                <div className="d-flex align-items-center justify-content-center">
                  {showViewButton &&
                    viewBtnVisible &&
                    showActionButtons &&
                    !variationsTable && (
                      <button
                        className="btn btn-sm btn-secondary d-flex align-items-center me-2"
                        onClick={() => handleProductClick(product?.id)}
                        data-bs-toggle="offcanvas"
                        data-bs-target={`#offcanvasRightView`}
                        aria-controls={`offcanvasRightView`}
                      >
                        <i className="ri-eye-fill me-1" />
                        {`${t("global.view")}`}
                      </button>
                    )}

                  <button
                    disabled={
                      window.location.pathname?.includes("/workflow/step4")
                        ? false
                        : editDisabledBtn()
                    }
                    className="btn btn-sm btn-warning d-flex align-items-center me-2"
                    onClick={
                      nameOfTable === "productByAttribute"
                        ? () =>
                            onEditAtt(
                              product?.id as number,
                              product?.status as string,
                              product?.isImported as boolean
                            )
                        : (e: any) => onEdit(e, product?.id as number)
                    }
                    onContextMenu={
                      nameOfTable === "productByAttribute"
                        ? () =>
                            onEditAtt(
                              product?.id as number,
                              product?.status as string,
                              product?.isImported as boolean
                            )
                        : (e: any) => onEdit(e, product?.id as number)
                    }
                  >
                    <i className="ri-edit-2-fill me-1" />
                    {`${t("global.edit")}`}
                  </button>
                  {window.location.pathname?.includes(
                    "admin/attributes/list/"
                  ) ||
                    (!disabledDeleteBtn &&
                      showDeleteButton &&
                      showActionButtons && (
                        <>
                          <button
                            className="btn btn-sm btn-danger d-flex align-items-center"
                            data-toggle={isExportList === true ? "tooltip" : ""}
                            title={"Remove only from export"}
                            data-placement="top"
                            onClick={() => {
                              if (nameOfTable === "variations") {
                                setSelectedProduct(product?.product);
                                setSelectedVariation(product);
                                handleShow();
                              } else {
                                setSelectedProduct(product);
                                setSelectedVariation(product?.variation);
                                handleShow();
                              }
                            }}
                          >
                            <i className="ri-delete-bin-fill me-1" />
                            {isExportList === true ||
                            nameOfTable === "baseMainWorkflow"
                              ? `${t("global.remove")}`
                              : `${t("global.delete")}`}
                          </button>
                        </>
                      ))}
                </div>

                <ConfirmDelete
                  show={show}
                  setShow={setShow}
                  itemName={
                    nameOfTable === "variations"
                      ? selectedVariation?.title
                      : selectedProduct?.title
                  }
                  deleteHandler={deleteHandler}
                  selectedProduct={selectedProduct}
                  selectedVariation={selectedVariation}
                />
              </>
            ) : (
              <>
                {" "}
                <button
                  // disabled={disabledBtn}
                  // disabled={
                  //   window.location.pathname?.includes("/workflow/step4")
                  //     ? false
                  //     : editDisabledBtn()
                  // }
                  className="btn btn-sm btn-info "
                  onClick={
                    nameOfTable === "productByAttribute"
                      ? () =>
                          onEditAtt(
                            product?.id as number,
                            product?.status as string,
                            product?.isImported as boolean
                          )
                      : (e: any) => onEdit(e, product?.id as number)
                  }
                  onContextMenu={
                    nameOfTable === "productByAttribute"
                      ? () =>
                          onEditAtt(
                            product?.id as number,
                            product?.status as string,
                            product?.isImported as boolean
                          )
                      : (e: any) => onEdit(e, product?.id as number)
                  }
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="ri-eye-fill me-1" />
                    {`${t("global.view")}`}
                  </div>
                </button>
              </>
            )}
          </td>
        )}
      </tr>
    </>
  );
};
